import People from './People'
import List from './children/List'
import { CreateModal } from './children/components/filters'
import UsersBulkEditModal from './children/components/bulk-edit'
import UploadsModal from './children/components/uploads'
import UploadUsersModal from './children/components/upload-users'
import UploadPdisModal from './children/components/upload-pdis'
import UploadFeedbacksModal from './children/components/upload-feedbacks'
import UsersBindCommitteeModal from './children/components/bind-committee'
import UsersStagesAdministration from './children/components/stages-administration'
import UpdateUsersNetworks from './children/components/update-users-networks'
import ClearUsersNetwork from './children/components/clear-users-network'

export default People
export {
    List,
    CreateModal,
    UploadsModal,
    UploadUsersModal,
    UploadPdisModal,
    UploadFeedbacksModal,
    UsersBulkEditModal,
    UpdateUsersNetworks,
    ClearUsersNetwork,
    UsersBindCommitteeModal,
    UsersStagesAdministration,
}
